// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VeeValidate from "vee-validate";
import VueAnalytics from "vue-analytics";
import VueCurrencyFilter from "vue-currency-filter";
import VueCookies from "vue-cookies";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCoffee,
  faCameraRetro,
  faHandshake,
  faMoneyBillAlt,
  faPenAlt,
  faHome,
  faChevronLeft,
  faInfoCircle
} from "@fortawesome/free-solid-svg-icons";

import { faFolderOpen, faFileAlt } from "@fortawesome/free-regular-svg-icons";
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faGoogle
} from "@fortawesome/free-brands-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import DateFilter from "./helpers/date";
import App from "./App";
import router from "./router";
import { token } from "./helpers/get-token";
import store from "./store/index";

import StoryblokVue from 'storyblok-vue';

/* eslint-disable */
const isProd = process.env.NODE_ENV === "production";
const isTest = process.env.NODE_ENV === "test";
/* eslint-enable */
const ID = isProd ? "UA-123507567-1" : "UA-129183176-1";

library.add(
  faCoffee,
  faCameraRetro,
  faHandshake,
  faMoneyBillAlt,
  faPenAlt,
  faHome,
  faFolderOpen,
  faFileAlt,
  faChevronLeft,
  faFacebookF,
  faTwitter,
  faInstagram,
  faGoogle,
  faInfoCircle
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(VeeValidate);
Vue.use(VueAnalytics, {
  id: ID,
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd || isTest
  }
});

Vue.use(VueCurrencyFilter, {
  symbol: "€",
  thousandsSeparator: ".",
  fractionCount: "",
  fractionSeparator: "",
  symbolPosition: "front",
  symbolSpacing: true
});

Vue.use(VueCookies);

Vue.filter("date", DateFilter);
Vue.prototype.$eventHub = new Vue();

Vue.use(StoryblokVue)

new Vue({
  router,
  store,
  token,  
  render: h => h(App),
}).$mount('#app');